<template>
  <ChecklistModal
    :value="valueComp"
    @input="updateFilter"
    :items="items"
    :compare="(a, b) => a === b"
    :transform="item => ({ value: item, label: $tc(item, 1) })"
  >
    <template #input="{ items }">
      <div class="elder-input">
        <label class="elder-input__label">{{ $tc('type', 2) }}</label>
        <ButtonComponent class="elder-input__wrapper" :icon="['fal', 'user']" icon-placement="left">
          <template #label>
            <span v-html="getLabel(items)"></span>
            <FontAwesomeIcon class="ml-1" :icon="['fal', 'angle-down']" size="lg" />
          </template>
        </ButtonComponent>
      </div>
    </template>
  </ChecklistModal>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import ChecklistModal from '@/components/Select/ChecklistModal'
import { mapState } from 'vuex'

export default {
  props: ['value'],
  computed: {
    ...mapState(['enums']),
    valueComp() {
      return this.value instanceof Array ? this.value : [this.value].filter(Boolean)
    },
    items() {
      if (!this.enums.ContactType) return []
      return this.enums.ContactType.map(i => i.value)
    },
  },
  methods: {
    getLabel(items) {
      if (!items || !items.length) return this.$tc('type', 2)
      return items.map(i => this.$tc(i, 1)).join(', ')
    },
    updateFilter(value) {
      this.$emit('input', value)
    },
  },
  components: {
    ChecklistModal,
    ButtonComponent,
  },
}
</script>
